import StampApi from "./stamp";

export const clientStampApi = new StampApi();
